import React, { useEffect, useState } from 'react'

function Describe() {
    const [text, setText] = useState('');
    const fullText = "Hi, I'm Abdul Saboor";
    const [index, setIndex] = useState(0);
    const handleScrollToSection = (sectionId) => {
        const headerOffset = 80; // Adjust this value based on your header height
        const element = document.getElementById(sectionId);
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition - headerOffset;
    
        window.scrollTo({
          top: offsetPosition + window.pageYOffset,
          behavior: 'smooth'
        });
      }
      useEffect(() => {
        const typingSpeed = 100;
    
        const handleTyping = () => {
          setText(fullText.substring(0, index));
          
          // Reset to start after full text is typed
          if (index === fullText.length) {
            setTimeout(() => setIndex(0), 1000); // 1-second pause before restarting
          } else {
            setIndex(index + 1);
          }
        };
    
        const timeoutId = setTimeout(handleTyping, typingSpeed);
    
        return () => clearTimeout(timeoutId);
      }, [index]);
    return (
        <section id="hero" className="d-flex align-items-center">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 pt-5 pt-lg-0 order-2 order-lg-1 d-flex flex-column justify-content-center">
                        <h1 data-aos="fade-up">
                            <span style={{ fontSize: 40, fontWeight: "bold", color: "#27bd76" }}>{text}.</span>
                        </h1>
                        <h2 data-aos="fade-up">
                            I offer comprehensive development for mobile apps and websites, including design, development, and post-launch support.
                        </h2>

                        <div className="pt-5" data-aos="fade-up" data-aos-delay="800">
                            <a href="#" onClick={() => handleScrollToSection('about')} className="btn-get-started scrollto">Get Started</a>
                        </div>
                    </div>
                    <div className="col-lg-6 order-1 order-lg-2 hero-img" data-aos="fade-left" data-aos-delay="200">
                        <img src="./images/Hero.png" className="img-fluid animated" alt="Hero" />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Describe